import { Box, Grid2, Stack, Typography, useMediaQuery, useTheme } from "@mui/material"
import { ThemeContext } from "../../../Shared/Theme/ThemeContext"
import { useContext, useState } from "react";
import { getPlatform } from "../../../../utilities/orientationAndPlatform";
import Contact from "./Contact";
import NewContactButton from "./NewContactButton";
import { ContactEditorModalBase } from "./ContactModal/ContactEditorModalBase";
import { validateEmail } from "../../../../utilities/validation";


export default function ContactsContainer({...params}){

    let pageMode = params.pageMode
    let call_sign = params.call_sign
    let market = params.market
    let contacts = params.contacts
    let handleContactChange = params.handleContactChange

    let [isModalOpen, setIsModalOpen] = useState(false);
    let [input, setInput] = useState()
    let [saveButtonDisabled, setSaveButtonDisabled] = useState(true)
    let [confirmationScreenState, setConfirmationScreenState] = useState(false);
    let [isNewContact, setIsNewContact] = useState(false)
    

    function toggleModal(){
        if (pageMode !== 'edit') return
        else {
            if (isModalOpen) {
                setIsModalOpen(false)
                setSaveButtonDisabled(true)
            }
            else setIsModalOpen(true)
        }
    }
    

    const handleInput = (event, inputType) => {
        event.preventDefault()
        let newInput = event.target.value

        if (inputType === 'name' && input.name !==  newInput){
            input.name = newInput
            if (validateEmail(input.email)) setSaveButtonDisabled(false)
            else setSaveButtonDisabled(true)
        }

        else if (inputType === 'email'){
            input.email = newInput
            if (validateEmail(newInput)) setSaveButtonDisabled(false)
            else setSaveButtonDisabled(true)
        }

        setInput({...input})
    }


    let theme = useTheme()
    const { mode } = useContext(ThemeContext);
    let imageSrc = ''
    if (mode === 'light') imageSrc = '/icons/icons-light/icon-contacts-hamburger-light.svg'
    else if (mode === 'dark') imageSrc = '/icons/icons-dark/icon-contacts-hamburger-dark.svg'

    let isNarrowDesktop = useMediaQuery('(max-width:1261px)')
    let platform = getPlatform()
    let stackDirection = ''
    let stackLeftPadding = ''
    if (platform === 'mobile' || isNarrowDesktop) stackDirection = 'column'
    else if (platform === 'desktop') {
        stackDirection = 'row'
        stackLeftPadding = '25px'
    }


    function getContacts(_contact, index, contacts){

        if (index === 0 && platform === 'desktop') return

        let contact1 = contacts[index]
        if (platform === 'mobile' || isNarrowDesktop) return <Contact contact={contact1} isModalOpen={isModalOpen} toggleModal={toggleModal} setInput={setInput} setIsNewContact={setIsNewContact} key={contact1.email}/>
    
        else if (platform === 'desktop'){
            
            if (index % 2 === 1 && index + 1 < contacts.length){
                let contact2 = contacts[index+1]
                return (
                    <Stack direction={'column'} alignItems={'flex-start'} paddingLeft={stackLeftPadding} key={contact1.email}>
                        <Contact contact={contact1} isModalOpen={isModalOpen} toggleModal={toggleModal} setInput={setInput} setIsNewContact={setIsNewContact}/>
                        <Contact contact={contact2} isModalOpen={isModalOpen} toggleModal={toggleModal} setInput={setInput} setIsNewContact={setIsNewContact}/>
                    </Stack>
                )
            }

            else if (index % 2 === 1 && index + 1 === contacts.length) {
                return (
                    <Stack direction={'column'} alignItems={'flex-start'} paddingLeft={stackLeftPadding} key={contact1.email}>
                        <Contact contact={contact1} isModalOpen={isModalOpen} toggleModal={toggleModal} setInput={setInput} setIsNewContact={setIsNewContact}/>
                    </Stack>
                )    
            }
        }
    }


    return (
        <>
            <Box display={'flex'} justifyContent={'center'} position={'relative'} top={'18px'}>
                <Box backgroundColor={theme.palette.ChannelPage.stationcontacts} borderRadius={'20px'} padding={'5px 10px'} width={'186px'} height={'36px'} zIndex={9}>
                    <Stack direction={'row'}>
                        <Box 
                            component="img" src={imageSrc} zIndex={110}
                            width={'25px'} height={'17.5px'} 
                            padding={'2.5px'}
                            display={'flex'}
                            justifySelf={'flex-start'}
                            alignSelf={'center'}
                            id={'stationcontactshamburgericon'}
                        />
                        <Typography noWrap fontSize={'18px'} fontWeight={400} zIndex={2001}>{'Station Contacts'}</Typography>
                    </Stack>
                </Box>
            </Box>

            <Grid2 display={'flex'} justifyContent={'center'} paddingTop={'28px'} sx={{borderTop: '1px solid ' + theme.palette.ChannelPage.subheader.desktopdivider}}> 
                <Stack direction={stackDirection} alignItems={'flex-start'}>

                    <Stack direction={'column'} alignItems={'flex-start'} >
                        {(pageMode === 'edit') && (
                            <NewContactButton toggleModal={toggleModal} setInput={setInput} setIsNewContact={setIsNewContact}/>
                        )}
                        {(contacts.length > 0 && platform === 'desktop' && !isNarrowDesktop) && (<Contact contact={contacts[0]} isModalOpen={isModalOpen} toggleModal={toggleModal} setInput={setInput} setIsNewContact={setIsNewContact}/>)}
                    </Stack>
                    
                    {contacts.map((_contact, index, contacts) => getContacts(_contact, index, contacts))} 
                </Stack>
            </Grid2>

            <ContactEditorModalBase isModalOpen={isModalOpen} toggleModal={toggleModal} 
                                    input={input} setInput={setInput} handleInput={handleInput} 
                                    saveButtonDisabled={saveButtonDisabled} setSaveButtonDisabled={setSaveButtonDisabled}
                                    confirmationScreenState={confirmationScreenState} setConfirmationScreenState={setConfirmationScreenState} 
                                    isNewContact={isNewContact} 
                                    call_sign={call_sign} market={market}
                                    handleContactChange={handleContactChange}
            />
        </>
    )
}
